/* eslint-disable */
// 修改返回数值样式
// 输入参数是秒
import crypto from 'crypto'
function getLocalTime(nS1) {
    Date.prototype.Format = function(fmt) {
            // author: meizz
            const o = {
                'M+': this.getMonth() + 1, // 月份
                'd+': this.getDate(), // 日
                'h+': this.getHours(), // 小时
                'm+': this.getMinutes(), // 分
                's+': this.getSeconds(), // 秒
                'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
                S: this.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (this.getFullYear() + '').substr(4 - RegExp.$1.length)
                )
            }
            for (const k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1 ?
                        o[k] :
                        ('00' + o[k]).substr(('' + o[k]).length)
                    )
                }
            }
            return fmt
        }
        // var timezone = 8; //目标时区时间，东八区
        // var offset_GMT = new Date().getTimezoneOffset();
        // var offset_GMT_Time = -offset_GMT/60;
        // var newTimer = parseInt(nS1) * 1000-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = parseInt(nS1) * 1000
    const nn = new Date(newTimer).Format('yyyy-MM-dd hh:mm:ss')
    return nn
}

function dateFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
    ].map((item) => (item < 10 ? '0' + item : item))
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
}

function dateFormateC(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
    ].map((item) => (item < 10 ? '0' + item : item))
    return `${hour}时${min}分`
}
  /**
     * 验证手机号
     * @param {手机号} str
     * @returns
     */
   function isPoneAvailable(str) {
    // var myreg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/
    var myreg = /^1[3456789]\d{9}$/
    if (!myreg.test(str)) {
      return false
    } else {
      return true
    }
  }
/**
     * 验证中文姓名
     * @param {姓名} str
     * @returns
     */
 function isCNName(str) {
    const myreg1 = new RegExp(
      '^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]){1,25}$'
    )
    if (!myreg1.test(str)) {
      return false
    } else {
      return true
    }
  }
  function getmd5(data) {
    var a
    var md5 = crypto.createHash('md5')
    md5.update(data)
    a = md5.digest('hex')
    return a
  }
/**
 * 验证身份证
 * @param {身份证} str
 * @returns
 */
 function IdentityCodeValid(str) {
    var myreg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
    if (str === '111111111111111' || !myreg.test(str)) {
        return false
    } else {
        return true
    }
    }
function dateDayFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
    ].map((item) => (item < 10 ? '0' + item : item))
    return `${year}-${month}-${day}`
}

function formatnewDay(timestamp) {
    var date = new Date(timestamp)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate();
    [year, month, day] = [year, month, day].map((item) =>
        item < 10 ? '0' + item : item
    )
    return `${year}${month}${day}`
}

function dateFormateMin(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
        // let sec = date.getSeconds();
    ;
    [year, month, day, hour, min] = [year, month, day, hour, min].map((item) =>
        item < 10 ? '0' + item : item
    )
    return `${year}-${month}-${day} ${hour}:${min}`
}

function getTimes(str) {
    let len = 0
    try {
        len = str.toString().split('.')[1].length // 计算出小数点后有几位
    } catch (e) {
        len = 0 // 小数点后没有东西，就默认为零位
    }
    const m = Math.pow(10, len)
    return m
}

function floatAdd(arg1, arg2) {
    let r1, r2, m
    try {
        r1 = arg1.toString().split('.')[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split('.')[1].length
    } catch (e) {
        r2 = 0
    }
    const n = Math.max(r1, r2)
    m = Math.pow(10, n)
    return ((arg1 * m + arg2 * m) / m).toFixed(n)
}

function floatSub(arg1, arg2) {
    let r1, r2, m, n
    try {
        r1 = arg1.toString().split('.')[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split('.')[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
        // last modify by deeka
        // 动态控制精度长度
    n = r1 >= r2 ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

function floatMul(arg1, arg2) {
    if (arg1 && arg2) {
        let m = 0
        const s1 = Number(arg1).toString()
        const s2 = Number(arg2).toString()
        try {
            m += s1.split('.')[1].length
        } catch (e) {}
        try {
            m += s2.split('.')[1].length
        } catch (e) {}
        return (
            (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
            Math.pow(10, m)
        ).toFixed(m)
    } else {
        return 0
    }
}

// 浮点数除法运算
function floatDiv(arg1, arg2) {
    arg1 = Number(arg1)
    arg2 = Number(arg2)
    var t1 = 0
    var t2 = 0
    var r1
    var r2
    try {
        t1 = arg1.toString().split('.')[1].length
    } catch (e) {}
    try {
        t2 = arg2.toString().split('.')[1].length
    } catch (e) {}
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    let n = 0
    if (t2 > t1) {
        n = t2 - t1
    } else {
        n = t1 - t2
    }
    return ((r1 / r2) * Math.pow(10, t2 - t1)).toFixed(n)
}
// 截取图片
function getSmallBase64(url, callback) {
    var Img = new Image()
    var dataURL = ''
    var drawEncoderOptions =
        40000.0 / url.length > 1 ? 0.92 : 40000.0 / url.length
    Img.src = 'data:image/jpeg;base64,' + url
    Img.onload = function() {
        // 异步
        var canvas = document.createElement('canvas')
        var width = Img.width
        var height = Img.height
        canvas.width = 300
        canvas.height = 300.0 * (height / width)
        canvas.getContext('2d').drawImage(Img, 0, 0, 300, 300 * (height / width))
        dataURL = canvas.toDataURL('image/jpeg')
        const i = dataURL.indexOf(',') // 截取data:image/png;base64,后的内容
        const imageName = dataURL.substring(i + 1, dataURL.length) // 把图片的二进制流付给表单ruleFinancingForm里面的idImage
        callback ? callback(imageName, drawEncoderOptions) : null
    }
}

function getmonday() {
    const now = new Date()
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    now.setMilliseconds(0)
    const nowTime = now.getTime()
    const day = now.getDay()
    const oneDayLong = 24 * 60 * 60 * 1000
    const mondayTime = nowTime - (day - 1) * oneDayLong
    return mondayTime
}

function exactPointTwo(num, arrIndex, arrProperty) {
    let newVal
    num = Number(num)
    if (num < 0) {
        num = num.toString().substring(1)
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/)) * -1
    } else {
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
    }
    // 整数自动补0
    if (newVal.toString().indexOf('.') == -1) {
        newVal += '.00'
    }
    const len = newVal.toString().indexOf('.') + 1
        // 1位数自动补0
    if (
        newVal
        .toString()
        .substring(len)
        .split('').length == 1
    ) {
        newVal += '0'
    }
    if (arrProperty) {
        arrIndex[arrProperty] = newVal
    }
    return newVal
}
// 判断并转换时间戳
function DateFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var min = date.getMinutes()
    var sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
    ].map((item) => (item < 10 ? '0' + item : item))
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
}

function coinDigitalNum() {
    const num = window.c.HY_ZICHAN_coinDigitalNum
    if (num && num == 0) {
        return 0
    }
    if (num) {
        return window.c.HY_ZICHAN_coinDigitalNum
    }
    return 2
}
// 获取时区并返回tradingView时区字符串
function getTimeZoneStr() {
    var offset_GMT = new Date().getTimezoneOffset()
    var offset_GMT_Time = -offset_GMT / 60 // 东正 西负
    switch (offset_GMT_Time) {
        case -11:
            {
                return 'Pacific/Honolulu' // wu1
            }
            break
        case -10:
            {
                return 'Pacific/Honolulu'
            }
            break
        case -9:
            {
                return 'America/Juneau'
            }
            break
        case -8:
            {
                return 'America/Los_Angeles'
            }
            break
        case -7:
            {
                return 'America/Phoenix'
            }
            break
        case -6:
            {
                return 'America/El_Salvador'
            }
            break
        case -5:
            {
                return 'America/Bogota'
            }
            break
        case -4:
            {
                return 'America/Caracas'
            }
            break
        case -3:
            {
                return 'America/Sao_Paulo'
            }
            break
        case -2:
            {
                return 'America/Sao_Paulo' // wu
            }
            break
        case -1:
            {
                return 'Pacific/Honolulu'
            }
            break
        case 0:
            {
                // return 'Atlantic/Reykjavik'
                return 'Etc/UTC'
            }
            break
        case 1:
            {
                return 'Europe/Madrid'
            }
            break
        case 2:
            {
                return 'Africa/Cairo'
            }
            break
        case 3:
            {
                return 'Europe/Moscow'
            }
            break
        case 4:
            {
                return 'Asia/Dubai'
            }
            break
        case 5:
            {
                return 'Asia/Kolkata'
            }
            break
        case 5.5:
            {
                return 'Asia/Kolkata'
            }
            break
        case 6:
            {
                return 'Asia/Almaty'
            }
            break
        case 7:
            {
                return 'Asia/Bangkok'
            }
            break
        case 8:
            {
                return 'Asia/Hong_Kong'
            }
            break
        case 9:
            {
                return 'Asia/Tokyo'
            }
            break
        case 10:
            {
                return 'Australia/Sydney'
            }
            break
        case 11:
            {
                return 'Australia/Sydney' // 所罗门群岛
            }
            break
        case 12:
            {
                return 'Pacific/Auckland'
            }
            break

        default:
            {
                return 'Etc/UTC'
            }
            break
    }
}
// 当前时间 时分秒
function nowMinFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
    ].map((item) => (item < 10 ? '0' + item : item))
    return `${hour}:${min}:${sec}`
}
// 时分秒转换为秒
function timeEvent(e) {
    var time = e
    var len = time.split(':')
    if (len.length == 3) {
        var hour = time.split(':')[0]
        var min = time.split(':')[1]
        var sec = time.split(':')[2]
        return Number(hour * 3600) + Number(min * 60) + Number(sec)
    }
    if (len.length == 2) {
        var min = time.split(':')[0]
        var sec = time.split(':')[1]
        return Number(min * 60) + Number(sec)
    }
    if (len.length == 1) {
        var sec = time.split(':')[0]
        return Number(sec)
    }
}
// 负数千分位处理
function formatNum(strNum) {
    var outputmoney = function(number) {
            number = number.replace(/\,/g, '') // 把所有的逗号，清除
            if (isNaN(number) || number === '') return ''
            number = Math.round(number * 100) / 100
            if (number < 0) { return '-' + outputdollars(Math.floor(Math.abs(number) - 0) + '') + outputcents(Math.abs(number) - 0) } else { return outputdollars(Math.floor(number - 0) + '') + outputcents(number - 0) }
        }
        // 格式化金额
    var outputdollars = function(number) {
        if (number.length <= 3) { return (number === '' ? '0' : number) } else {
            var mod = number.length % 3
            var output = (mod === 0 ? '' : (number.substring(0, mod)))
            for (let i = 0; i < Math.floor(number.length / 3); i++) {
                if ((mod === 0) && (i === 0)) { output += number.substring(mod + 3 * i, mod + 3 * i + 3) } else { output += ',' + number.substring(mod + 3 * i, mod + 3 * i + 3) }
            }
            return (output)
        }
    }
    var outputcents = function(amount) {
        amount = Math.round(((amount) - Math.floor(amount)) * 100)
        return (amount < 10 ? '.0' + amount : '.' + amount)
    }
    return outputmoney(strNum + '')
}
// 向下取整保留n位小数
function floorFun(value, n) {
  return Math.floor(value*Math.pow(10,n))/Math.pow(10,n);
}
// 四舍五入取整保留n位小数
function roundFun(value, n) {
  return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
}
// 向上取整保留n位小数
function ceilFun(value, n) {
  return Math.ceil(value*Math.pow(10,n))/Math.pow(10,n);
}
export {
    nowMinFormate,
    timeEvent,
    getLocalTime,
    dateFormate,
    dateFormateMin,
    dateDayFormate,
    formatnewDay,
    getTimes,
    floatAdd,
    floatSub,
    floatMul,
    floatDiv,
    getSmallBase64,
    getmonday,
    exactPointTwo,
    DateFormate,
    coinDigitalNum,
    getTimeZoneStr,
    dateFormateC,
    isPoneAvailable,
    isCNName,
    IdentityCodeValid,
    formatNum,
    floorFun,
    roundFun,
    ceilFun,
    getmd5

}